import React from 'react'

//Components.
import CompletedChallengesComponent from '../../../components/challenges/completedChallenges/CompletedChallengesComponent';

//Dependencies.
import { useSelector } from 'react-redux';

//Slice Data.
import { completedChallenges } from '../../../slices/challengesSlice';
import { Container } from 'reactstrap';

const CompletedChallengesPage = () => {
  const challengesCompleted = useSelector(completedChallenges);

  return (
    <div>
      {
        (Object.values(challengesCompleted).length > 0) ? 
          <CompletedChallengesComponent />
          :
          <Container style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <h1 className='text-danger'>THERE ARE CURRENTLY <em>NO</em> COMPLETED CHALLENGES...</h1>
            <h5><em>Please check back later.</em></h5>
          </Container>
      }
    </div>
  )
}

export default CompletedChallengesPage